module.exports = __webpack_public_path__ + "static/media/Quest-Deep_and_Deeper.e53cfb4b.png";